import React from 'react';
import { Table } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import ActionButton from '../../../../components/common/buttonEditAndDelete';
const TableCountryList = props => (
  <Table basic="very" selectable fixed>
    <Table.Header>
      <Table.Row>
        {props.headerTable.map((headTableContent, index) => {
          return (
            <Table.HeaderCell key={index}>{headTableContent}</Table.HeaderCell>
          );
        })}
      </Table.Row>
    </Table.Header>

    <Table.Body>
      {props.listData ? (
        props.listData.map((country, idx) => {
          return (
            <Table.Row key={idx}>
              <Table.Cell>{country.Id}</Table.Cell>
              <Table.Cell>{country.Name}</Table.Cell>
              <Table.Cell>
                {country.IsCountryRelevant === true ? 'YES' : 'NO'}
              </Table.Cell>
              <ActionButton
                id={country.Id}
                handleClickEdit={props.butttonEdit}
                handleClickDelete={props.buttonDelete}
                name1="Edit"
                name2={country.Name}
                content1="Edit"
                content2="Delete"
              />
            </Table.Row>
          );
        })
      ) : (
        <Table.Row>
          <Table.Cell colSpan="4" textAlign="center">
            No Data
          </Table.Cell>
        </Table.Row>
      )}
    </Table.Body>
  </Table>
);

TableCountryList.propTypes = {
  listData: PropTypes.array,
  headerTable: PropTypes.array,
  actionButton: PropTypes.func,
  butttonEdit: PropTypes.func,
  buttonDelete: PropTypes.func,
};
export default TableCountryList;
